import React from 'react';
import {Divider} from 'antd';
import { Link } from 'dva/router';
import LinesEllipsis from 'react-lines-ellipsis';

export default ({novel_id, name, pic, author, cata, brief}) => (
<div>
    <Link to={`/book/detail/${novel_id}`}>
        <div>
            <em style={{width:'212px',height:'270px',display:'block'}}>
                <img alt='' src={pic} style={{height: '100%',width: '100%'}}/>
            </em>
            <div style={{maxWidth:'212px',fontSize: '16px',lineHeight: '22px',color: '#333333',margin:'10px 0 2px',textAlign:'center'}}>
                <LinesEllipsis maxLine={1} text={name}/>
            </div> 
            <div style={{fontSize: '14px',lineHeight: '20px',color: '#999999',textAlign:'center'}}>
                {cata}{author && <span><Divider type="vertical" />{author}</span>}
            </div>
        </div>
    </Link>
</div>
)



// WEBPACK FOOTER //
// ./src/component/book/styl_brief_10.js